import { ReportingPageName } from '@libs/types';

/** Hub pages that have implemented HubPage */
export const HUB_PAGES_CONVERTED = [
  ReportingPageName.Dashboard,
] as ReportingPageName[];
